exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-item[data-v-c4e45ed2] {\n  margin-bottom: 16px;\n  padding: 6px 12px;\n  border: 1px solid #e0e0e0;\n}\n.title-item[data-v-c4e45ed2] {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 12px;\n}\n", ""]);

// exports
